module.exports = __webpack_public_path__ + "static/media/wine_sale.79009ad6.jpg";